module.exports = __webpack_public_path__ + "static/img/banner3.e75dcf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner3.jpg
// module id = 1OG7
// module chunks = 12